export enum StatusModel {
    PENDING = "PENDING",
    IN_PROGRESS = "IN_PROGRESS",
    ON_HOLD = "ON_HOLD",
    COMPLETED = "COMPLETED",
    DISCARDED = "DISCARDED"
}